import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#5fcb74",
      stroke: "#5fcb74",
      "stroke-width": ".6",
      d: "M3.8 12.2a9 9 0 1 1 18 0 9 9 0 0 1-18 0Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M10.2 11.6a7.2 7.2 0 0 0 3.1 3.1l1-1c.2-.2.4-.2.6-.1l1.7.2c.2 0 .5.2.5.5V16c0 .2-.3.4-.5.4a8.1 8.1 0 0 1-8.2-8c0-.3.3-.6.5-.6h1.7c.3 0 .5.3.5.5 0 .6 0 1.2.3 1.7 0 .2 0 .4-.2.5l-1 1Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }